import { io, Socket } from "socket.io-client";

const getApiUrl = () => {
  return (
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "development"
      ? "http://localhost:8080"
      : "https://hdg-api-service-485830218751.us-central1.run.app")
  );
};

export const createMessageSocket = (userId: string, role: string): Socket => {
  return io(getApiUrl(), {
    transports: ["websocket"],
    auth: {
      userId,
      role,
    },
  });
};

export const createRealtimeSocket = createMessageSocket;
